import FilterParamsUtil from '../../sections/collection-grid/filter-params-util'


const CollectionFilterSpPriceRange = (el, onClose) => {


  let filterParams = []


  const initialize = () => {
    el.querySelector('.fs-back-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(false, null)
    })
    el.querySelector('.fs-close-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(true, null)
    })
    el.querySelector('.fs-clear-button').addEventListener('click', () => {
      const newFilterParams = filterParams.filter(kv => !kv.key.startsWith('price_'))
      handleChangeFilterParams(newFilterParams)
    })
    el.querySelector('.fs-select-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(false, filterParams)
    })
    el.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', e => {
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name)
        if (!e.target.value || e.target.value.length <= 0) {
          handleChangeFilterParams(newFilterParams)
        } else {
          handleChangeFilterParams([...newFilterParams, {key: e.target.name, value: e.target.value}])
        }
      })
    })
  }


  const show = (newFilterParams) => {
    filterParams = FilterParamsUtil.duplicate(newFilterParams)
    handleChangeFilterParams(newFilterParams)
    el.classList.add('show')
  }


  const handleChangeFilterParams = (newFilterParams) => {
    if (filterParams == newFilterParams) {
      return
    }
    el.querySelectorAll('input').forEach(input => {
      input.value = newFilterParams.find(kv => kv.key == input.name)?.value ?? null
    })
    filterParams = newFilterParams
  }


  initialize()

  return {
    show: show
  }
}


export default CollectionFilterSpPriceRange
